<template>
  <div class="footer-section">
    <div class="footer-institucional__wrapper">
      <a href="/termos" class="z-link y-footer__link z-link--small ">
        Termos e Condições
      </a>
      <a href="/privacidade" class="z-link y-footer__link z-link--small">
        Política de privacidade
      </a>
      <a href="/politica-de-cookies" class="z-link y-footer__link z-link--small">
        Política de cookies
      </a>
    </div>
    <div class="footer-section__wrapper">
      <z-text size="small" color="inverted" align="center" class="footer__about-quero">
        Quero Pago ® 2018 - 2021 / CNPJ: 10.542.212/0001-54
      </z-text>
      <z-text size="small" color="inverted">
        Feito com
        <z-icon tag="span" size="medium" color="inverted" :icon="['far', 'heart']" />
        pela
        <z-text tag="span" size="small" color="inverted" weight="bold">
          Quero Educação
        </z-text>
      </z-text>
    </div>
  </div>
</template>

<script>
import { ZText, ZIcon } from '@quero/zilla-vue';

export default {
  components: {
    ZText,
    ZIcon,
  },
};
</script>

<style lang="scss" scoped>
.footer-section {
  display: flex;
  flex-direction: column;
  background-color: var(--color-blue-700);
  padding: var(--space-extra-large) var(--space-medium);
  width: 100%;
  gap: var(--size-large);
}

.footer-institucional__wrapper,
.footer-section__wrapper {
  align-items: center;
  display: flex;
  justify-content: center;
  margin: 0 auto;
  position: relative;
  width: 1140px;
  z-index: 1;

  @media screen and (max-width: $screen-md-max) {
    flex-direction: column;
    width: 100%;
  }
}

.footer-institucional__wrapper {
  gap: var(--size-medium) var(--size-extra-large);

  & .y-footer__link {
    align-items: center;
    color: var(--color-font-inverted);
    display: flex;
    font-size: 14px;
    min-height: var(--size-jumbo);
    min-width: var(--size-jumbo);
  }
}

.footer__about-quero {
  margin-right: var(--space-large);

  @media screen and (max-width: $screen-md-max) {
    margin-right: 0;
  }
}
</style>
